<template>
  <b-navbar>
    <template slot="start">
      <b-navbar-item href="#">
        Start
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
  export default {
    name: 'Menu'
  }
</script>

<style scoped>
  .me {
    filter: grayscale(100%);
  }
</style>
